import { Cell, Label, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { GradeBand } from '@peekapak/types/EmotionsClassification';
import { getMoodDisplayName } from '@peekapak/types/Mood';
import { SectionSummary } from './ConcerningEmotionsReportSummary';
import { getEmotionColor } from './ConcerningEmotionsReportUtilities';
import styles from './ConcerningEmotionsReport.module.scss';

interface Props {
  summary: SectionSummary;
  gradeBand: GradeBand;
}

const ConcerningEmotionsReportSummaryWidget = ({ summary, gradeBand }: Props): JSX.Element => {
  const pieData = summary.byFeeling.map(({ feeling, count }) => ({
    name: `${getMoodDisplayName(feeling)} (${count})`,
    value: count,
    color: getEmotionColor(feeling, gradeBand).backgroundColor,
  }));
  // Legend entries are laid out vertically and need room to grow with the list,
  // or they render past the fixed-height chart's bottom edge.
  const chartHeight = Math.max(160, pieData.length * 24);

  return (
    <div className={styles.summaryWidget}>
      <div className={styles.summaryChart}>
        <p className={styles.summaryChartLabel}>Down moods this period</p>
        <ResponsiveContainer width={320} height={chartHeight}>
          <PieChart>
            <Pie data={pieData} dataKey='value' nameKey='name' innerRadius={45} outerRadius={70}>
              <Label value={summary.totalDownMoods} position='center' className={styles.summaryChartTotal} />
              {pieData.map((entry) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
            <Legend
              layout='vertical'
              align='right'
              verticalAlign='middle'
              wrapperStyle={{ paddingLeft: '1rem' }}
              formatter={(value) => <span style={{ color: '#000000' }}>{value}</span>}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className={styles.summaryCards}>
        {summary.byFeeling.map(({ feeling, count }) => (
          <div key={getMoodDisplayName(feeling)} className={styles.summaryCard}>
            <p className={styles.summaryCardCount}>{count}</p>
            <p className={styles.summaryCardLabel}>{getMoodDisplayName(feeling)}</p>
          </div>
        ))}
        <div className={styles.summaryCard}>
          <p className={styles.summaryCardCount}>{summary.totalDownMoods}</p>
          <p className={styles.summaryCardLabel}>Total down moods</p>
        </div>
      </div>
    </div>
  );
};

export default ConcerningEmotionsReportSummaryWidget;
